$(document).ready(function(){

  // index custom slideshow with text - begin
  var $customHomeSlider = $('.custom-index-slidehow');
  // var index = $('.custom-index-slidehow').data('index');
  $customHomeSlider.flickity({
  // options
  cellAlign: 'right',
  prevNextButtons: false,
  contain: true
});
  // index = index - 1;
  index = 1;
  $customHomeSlider.flickity( 'select', index, true, true );
  // index custom slideshow with text - end


// sticky header
var winWidth = $(window).width();
if (winWidth > 798 ) {
        //add for sticky menu
        //offset() measures how far down the sticky element is from the top of the window
        var stickyTop = $(".header").offset().top;
        //whenever the user scrolls, measure how far we have scrolled
        $(window).scroll(function() {
          var windowTop = $(window).scrollTop();
          //check to see if we have scrolled past the original location of the sticky element
          if (windowTop > stickyTop) {
            //if so, change the sticky element to fised positioning
            $(".desktop-nav").addClass("stuck");

            if($('.promo_banner-show').length > 0){
               $("body").css("margin-top", "99px");
             }else{
               $("body").css("margin-top", "69px");
             }
           
            // $(".top_bar").addClass("no-stuck");
          } else {
            $(".desktop-nav").removeClass("stuck");
            $("body").css("margin-top", "0");
            // $(".top_bar").removeClass("no-stuck");
          }
        });
      }
// sticky header

});




